import { render, staticRenderFns } from "./crudCategories.vue?vue&type=template&id=43648c89&scoped=true&"
import script from "./crudCategories.vue?vue&type=script&lang=js&"
export * from "./crudCategories.vue?vue&type=script&lang=js&"
import style0 from "./crudCategories.vue?vue&type=style&index=0&id=43648c89&prod&lang=css&"
import style1 from "./crudCategories.vue?vue&type=style&index=1&id=43648c89&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43648c89",
  null
  
)

export default component.exports